import React from 'react';
import { flavoredPath } from 'javascripts/flavor';
import { urlWithProtocol } from 'javascripts/url_helpers';
import { type CardContentsComponent } from 'components/CardLayoutEditor/models/types';
import { sanitizeUrl } from 'javascripts/sanitizer';

const TextContents: React.FC<CardContentsComponent<'text'>> = ({
  text,
  contents,
}) => {
  if ('url' in contents) {
    const { url } = contents;

    return (
      <a
        href={flavoredPath(sanitizeUrl(url))}
        data-drawer-url={flavoredPath(sanitizeUrl(url))}
      >
        {text}
      </a>
    );
  } else if ('externalUrl' in contents) {
    const { externalUrl } = contents;

    return (
      <a
        href={sanitizeUrl(urlWithProtocol(externalUrl))}
        target='_blank'
        rel='noopener noreferrer nofollow'
      >
        {text}
      </a>
    );
  }

  return <span>{text}</span>;
};

export default TextContents;
